document.addEventListener('DOMContentLoaded', function () {
  const lightbox = document.getElementById('lightbox');
  const imgEl = document.getElementById('lightbox-img');
  const closeBtn = lightbox.querySelector('.lightbox-close');

  // ONE handler for both anchors and image-map areas
  document.body.addEventListener('click', function (e) {
    const trigger = e.target.closest('a.lightbox-trigger, area.lightbox-trigger');
    if (!trigger) return;

    e.preventDefault();
    const src = trigger.getAttribute('data-lightbox-src') || trigger.getAttribute('href');
    if (!src) return;

    imgEl.src = src;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    closeBtn && closeBtn.focus?.();
  });

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }

  closeBtn.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox(); });
});